/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Skeleton,
} from "@chakra-ui/react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { css } from "@emotion/react";
import { MdClose } from "react-icons/md";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .subtitle {
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;

    margin-bottom: 4px;
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 24px;

  img {
    margin-right: 16px;
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;

  padding: 8px;

  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    color: #868482;
  }
`;

interface BlackWhiteListModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function BlackWhiteListModal({
  isOpen,
  onClose,
}: BlackWhiteListModalProps) {
  return (
    <Modal isCentered motionPreset="scale" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxWidth="640px"
        width="calc(100% - 16px)"
        pt="24px"
        pb="48px"
        position="relative"
      >
        <ModalHeader
          fontSize="20px"
          fontWeight="600"
          display="flex"
          alignItems="center"
          justifyContent="start"
          gridGap="8px"
          px={["24px", "32px", "40px", "48px"]}
        >
          <AiOutlineQuestionCircle width="20px" height="20px" color="#FB972E" />{" "}
          What’s the difference between Blacklist and Whitelist?
        </ModalHeader>

        <CloseButtonWrapper onClick={onClose}>
          <MdClose />
        </CloseButtonWrapper>

        <ModalBody px={["24px", "32px", "40px", "48px"]}>
          <Content>
            <Flex>
              <img src="/icons/blocking/blacklist.svg" alt="Internal" />
              <div className="text-wrapper">
                <div className="subtitle">Blacklist</div>
                <div className="text">
                  Blocks all users from the countries selected.
                </div>
              </div>
            </Flex>

            <Flex>
              <img src="/icons/blocking/whitelist.svg" alt="External" />

              <div className="text-wrapper">
                <div className="subtitle">Whitelist</div>
                <div className="text">
                  Only allows users from the countries selected.
                </div>
              </div>
            </Flex>
          </Content>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
